export const ChatState = {
    Open: 1,
    Closed: 2,
    Minimized: 3
};
export const ChatSize = {
    Small: 1,
    Large: 2
};
export const ChatStatus = {
    awaitingPickup: 1,
    active: 2,
    inactive: 3,
    requested: 4,
    botHandling: 5
};
export const ChatTabType = {
    Slide: 1,
    Blink: 2,
    ColorChange: 3
};
export const ChatbarPosition = {
    Top: 1,
    Bottom: 2,
    Left: 3,
    Right: 4
};
export const ChatbarStyle = {
    Rounded: 1,
    Squared: 2
};
export const Position = {
    Left: 1,
    Right: 2,
    Middle: 3,
    Center: 4,
    LeftCenter: 5,
    RightCenter: 6,
    TopLeft: 7,
    TopMiddle: 8,
    TopRight: 9
};
export const LogLevel = {
    Debug: 1,
    Warn: 2,
    Error: 3
};
export const InvitationDisplayMode = {
    Drop: 1,
    Appear: 2,
    Slide: 3,
    SlideFromLeft: 4,
    SlideFromRight: 5,
    HideAndShowTab: 6
};
export const InvitationTabDirection = {
    Down: 1,
    Left: 2,
    Right: 3
};
export const SkinInviteType = {
    Standard: 1,
    Image: 2,
};
export const ThemeStyle = {
    Default: 1,
    Rounded_Dynamic: 2,
    Rounded_Dynamic_Plus: 3,
};
export const SkinRegionType = {
    ProfileText: 1,
    FixedText: 2,
    Action: 3,
    Image: 4,
    AgentImage: 5,
    VideoChat: 6,
    OnlineIndicator: 7
};
export const InvitationAction = {
    StartChat: 1,
    Close: 2
};
export const InviteSize = {
    Full: 1,
    Minimized: 2,
    InProgress: 3,
    ExitPopup: 4
};

export const VisitorResponseType = {
    Name: 1,
    Phone: 2,
    Email: 3,
    Message: 4,
    Region: 5,
    Address: 6
};
export const SystemMessageType = {
    Default: 100,
    SMSTransferInProgress: 1,
    SMSTransferred: 2,
    SMSTransferFailed: 3,
    TransferToLiveAgent: 4,
    TransferToLiveAgentFailed: 5,
    SMSOptIn: 6,
    WebToSMSTransferCompleted: 7,
    WebToSMSTransferInitiated: 8
};
export const AgentScriptActionType = {
    callConnect: 1,
    sendLead: 2,
    endChat: 3,
    markLeadAsSales: 4,
    markLeadAsService: 5,
    markLeadAsOther: 6,
    transferToLiveAgent: 7,
    convertToSMS: 8
};

export const ScriptsQuestionType = {
    None: 0,
    MultipleChoice: 1,
    TrueOrFalse: 2,
    Text: 3,
    Time: 4,
    TimeCalendar: 5,
    CalendarDate: 6,
    FullText: 8,
    AllThatApply: 7,
    AppointmentScheduler: 9,
    MultipleChoiceConsent: 10,
    VideoGreet: 11,
    WebToSMSNotification: 12,
    PhoneOTPDialog: 13,
    FileAttachment: 14
};

export const ScriptVisitorResponseStatus = {
    UnAnswered: 0,
    Skipped: 1,
    Answered: 2,
    Updating: 3
};
export const MobileDisplayMode = {
    Default: 1,
    FixedToScreen: 2,
    Offscreen: 3
};
export const ChatType = {
    standard: 1,
    sms: 2,
    standard_sms_facebook: 3,
    standard_sms: 4,
    standard_facebook: 5,
    facebook_sms: 6
};
export const AnimationType = {
    None: 1,
    Flip: 2,
    Glow: 3
};
export const LogoLocation = {
    Header: 1,
    Side: 2
};
export const PreChatMessageAnimation = {
    Default: 1,
    Stacking: 2,
    MobileStacking: 3
};
export const PreChatMessageType = {
    agent_Script: 1,
    plain_Text: 2
};
export const QTGridMessageType = {
    agent_Script: 1,
    plain_Text: 2
};
export const VISITOR_MESSAGE_SOUND = {
    // sound for visitor messages
    name: 'visitorMessageSound',
    tune: 'waterdrop'
}